import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export function convertDateTime(date: string) {
  return new Date(date).toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  });
}

export function convertDate(date: string) {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function getRandomColorTag() {
  // return [
  //   "magenta",
  //   "red",
  //   "volcano",
  //   "orange",
  //   "gold",
  //   "lime",
  //   "green",
  //   "cyan",
  //   "blue",
  //   "geekblue",
  //   "purple",
  // ][Math.floor(Math.random() * 10)];
  return "geekblue";
}

export function formatDateTime(isoString: any) {
  return dayjs(isoString).format("h:mm A");
}

export function getRandomColor() {
  return [
    "magenta",
    "red",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ][Math.floor(Math.random() * 10)];
}

export function convertTime(date: string) {
  return new Date(date).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  });
}

export const handleFileUpload = async (
  file: File,
  setFile: Function,
  setError: Function
) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const res = await fetch("/upload", {
      method: "POST",
      body: formData,
    });

    if (res.status === 200) {
      const data = await res.json();
      setFile(data.file);
    } else {
      setError(await res.text());
    }
  } catch (err: any) {
    setError(err.message);
  }
};

export function formatDate(dateStr: string) {
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  const date = new Date(dateStr);
  // const day = date.getUTCDate().toString().padStart(2, "0");
  // const monthIndex = date.getUTCMonth();
  // const monthName = months[monthIndex];
  // const year = date.getUTCFullYear();
  const day = date.getDate().toString().padStart(2, "0");
  const monthIndex = date.getMonth();
  const monthName = months[monthIndex];
  const year = date.getFullYear();

  return `${day}-${monthName}-${year}`;
}

export function formatTime(timeStr: any) {
  console.log("🚀 ~ formatTime ~ timeStr:", timeStr);
  const date = new Date(timeStr);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12;

  const formattedTime = `${hours}:${minutes
    .toString()
    .padStart(2, "0")} ${period}`;
  return formattedTime;
}

export function convertToIST(dateString: string): string {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "Asia/Kolkata",
  };

  const weekday = date.toLocaleString("en-US", {
    weekday: "short",
    timeZone: "Asia/Kolkata",
  });
  const month = date.toLocaleString("en-US", {
    month: "short",
    timeZone: "Asia/Kolkata",
  });
  const day = date.toLocaleString("en-US", {
    day: "2-digit",
    timeZone: "Asia/Kolkata",
  });
  const year = date.toLocaleString("en-US", {
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });
  const time = date.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "Asia/Kolkata",
  });

  const istOffset = "+0530";
  const istString = `GMT${istOffset} (India Standard Time)`;

  const formattedDate = `${weekday} ${month} ${day} ${year} ${time} ${istString}`;

  return formattedDate;
}

export const getFileMimeTypeImage = (fileName: string): string => {
  console.log("🚀 ~ getFileMimeTypeImage ~ fileName:", fileName)
  if (fileName.includes("pdf")) {
    return "/assets/pdf_logo.svg";
  } else if (fileName.includes("doc") && !fileName.includes("docx")) {
    return "/assets/doc_logo.svg";
  } else if (fileName.includes("docx")) {
    return "/assets/docx_logo.svg";
  } else {
    return "/assets/pdf_logo.svg";
  }
};
